<template>
<a class="com-author-name" @click.stop="routePersonal">{{name}}</a>
<!-- <a
  class="com-author-name"
  @mouseenter="showPopup = true"
  @mouseleave="showPopup = false"
  @click.stop="routePersonal"
>
  {{name}}
  <FollowPopup :uid="uid" :visible="!isMobile && showPopup" v-if="follow" />
</a> -->
</template>

<script>
import VueTypes from 'vue-types'
// import {mapState} from 'vuex'
// import FollowPopup from '../list/FollowPopup'

/**
 * 作者名称
 * @desc 点击后跳转到作者的个人页面 `/profile/${this.uid}`
 * @module component/AuthorName
 * @example <AuthorName :uid="uid" :name="nickname" />
 */
export default {
  name: 'author-name',
  // components: {
  //   FollowPopup
  // },
  /**
   * 传入数据
   * @property {String|Number}  uuid     用户 ID
   * @property {String}         name     用户名称
   * @property {Boolean}        [follow=false]  [已废弃]是否使用浮框关注功能
   * @property {Boolean}        [open=false]  跳转是否新打开页面
   */
  props: {
    uid: VueTypes.oneOfType([Number, String]).isRequired,
    name: VueTypes.string.isRequired,
    follow: VueTypes.bool.def(false),
    open: VueTypes.bool.def(false)
  },
  // data () {
  //   return {
  //     showPopup: false
  //   }
  // },
  // computed: {
  //   ...mapState(['isMobile'])
  // },
  methods: {
    /**
     * 跳转到个人页面
     * @desc 跳转链接为 `/profile/${this.uid}`
     * @func
     */
    routePersonal () {
      window.open(`/profile/${this.uid}`)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';

.com-author-name {
  position: relative;
  cursor: pointer;
  @extend %animateFontHover;
  color: $lightBlack;
}
</style>

